import { Component, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FormField, FormFieldConfig } from "@app/forms/models";
import { parseTyped } from "@methods/CommonMethods";
import { CerrixVideoPlayerComponent } from "@app/shared/cerrix-video-player/cerrix-video-player.component";
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/forms/i18n/scope";

@Component({
    selector: "form-detail-video",
    templateUrl: "./form-detail-video.component.html",
    styleUrls: ["./form-detail-video.component.scss"],
    imports: [FormsModule, CerrixVideoPlayerComponent, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class FormDetailVideoComponent implements OnInit {
    @Input() field: FormField;
    videoSettings: FormFieldConfig;

    constructor() {}

    ngOnInit() {
        this.field.Required = false;
        this.videoSettings = parseTyped<FormFieldConfig>(
            this.field.CustomSettings,
            new FormFieldConfig()
        );
    }

    saveModel() {
        this.field.CustomSettings = JSON.stringify(this.videoSettings);
    }
}
